import { Line } from 'vue-chartjs'

export default {
    extends: Line,
    props: ['chartData'],
    data() {
        return {
            options: {
                responsive: false,
                maintainAspectRatio: true,
                legend: {
                    display: false
                },
                scales: {
                    xAxes: [{
                        ticks: {
                            display: false //this will remove only the label
                        }
                    }]
                },
                animation: false
            }
        }
    },
    mounted () {
        this.renderChart(this.chartData, this.options)
        // this.renderChart({
        //     labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
        //     datasets: [
        //         {
        //             label: 'Data One',
        //             backgroundColor: '#f87979',
        //             data: [40, 39, 10, 40, 39, 80, 40]
        //         }
        //     ]
        // }, {responsive: true, maintainAspectRatio: true})
    }
}
